/**
 * Created by amirb on 7/22/15.
 *
 * List of supported SDEs -
 *  1. Personal Info
 *  2. Customer Info
 *  3. Marketing Source
 *  4. Visitor Error
 *  5. Lead Generation
 *  6. Service Activity
 *  7. Transactions
 *  8. Shopping Cart Update
 *  9. Viewed Products
 *  10. Searched Content
 *
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');

    var lpSdeDataHandler = {
        handleEvents: handleEvents,
        getProcessedSDEsEvents: getProcessedSDEsEvents,
        //TODO: remove when seamless SDEs feature is finalized
        setDemoSeamlessSDEs: setDemoSeamlessSDEs,
        getProcessedCustomerInfoEvent: getProcessedCustomerInfoEvent,
        getProcessedPersonalInfoEvent: getProcessedPersonalInfoEvent
    };

    var currencySymbol = '';
    var modelAttributes = {
        lead:               {name: 'lead',              reversed: true,     eventName: 'lead',                  callback: getProcessedLeadEvent,            context: 'leads',                 shouldTrim: false },
        cart:               {name: 'cart',              reversed: false,    eventName: 'cartStatus',            callback: getProcessedCartEvent,            context: 'cart',                  shouldTrim: true },
        purchase:           {name: 'purchase',          reversed: true,     eventName: 'purchase',              callback: getProcessedPurchaseEvent,        context: 'purchases',             shouldTrim: false },
        vehicleOfInterest:  {name: 'vehicleOfInterest', reversed: true,     eventName: 'vehicleOfInterest',     callback: getProcessedVoiEvent,                                               shouldTrim: false },
        viewed:             {name: 'viewed',            reversed: true,     eventName: 'viewedProduct',         callback: getProcessedViewedEvent,                                            shouldTrim: false },
        personal:           {name: 'personal',          reversed: false,    eventName: 'personalInfo',          callback: getProcessedPersonalInfoEvent,    context: 'personalInfo',          shouldTrim: true },
        customer:           {name: 'customer',          reversed: false,    eventName: 'customerInfo',          callback: getProcessedCustomerInfoEvent,    context: 'customerInfo',          shouldTrim: true },
        marketing:          {name: 'marketing',         reversed: false,    eventName: 'marketingCampaignInfo', callback: getProcessedMarketingInfoEvent,   context: 'marketingCampaignInfo', shouldTrim: true },
        service:            {name: 'service',           reversed: false,    eventName: 'serviceActivity',       callback: getProcessedServiceActivityEvent, context: 'serviceActivity',       shouldTrim: true },
        visitorError:       {name: 'visitorError',      reversed: true,     eventName: 'visitorError',          callback: getProcessedVisitorErrorEvent,    context: 'visitorError',          shouldTrim: false },
        searchContent:      {name: 'searchContent',     reversed: true,     eventName: 'searchContent',         callback: getProcessedSearchContentEvent,   context: 'searchContent',         shouldTrim: false }
    };

    // Object for demo seamless SDEs POC.
    // TODO: Remove when feature is finalized
    var demoSeamlessSDEs = {};

    /**
     * This method will process the returned events and will separate & order them to their appropriate sub objects in the given collection
     * @param events - events to process
     * @param collection - destination collection to hold the events in the sub objects according to the event's name
     * @param [context] - Optional context for SDEs
     *
     * NOTE: In case you add another type of event, make sure you edit the code in the following places:
     *  - modelAttributes
     *  - eventNames
     *  - splitEventsByType
     */
    function handleEvents (events, collection, context) {
        var sortingFunction = lpUtils.getSortFunction("serverTimeStamp"); // General sorting function for the events

        if (events) {
            splitEventsByType(events, collection);
            getEventsFromContext(collection, context);
            orderAndTrimEventsByType(collection);
        }

        function trimEvents(collection, shouldTrim) {
            if (collection && Array.isArray(collection)) {
                if (shouldTrim) {
                    collection.splice(0, collection.length - 1);
                }
            }
        }

        /**
         * Separates the events to sub objects according to their type
         * @param events - events to separate
         * @param collection - destination collection to hold the events in the sub objects according to the event's name
         */
        function splitEventsByType(events, collection) {
            for (var eventIndex = 0; eventIndex < events.length; eventIndex++ ) {
                var event = events[eventIndex], nameByAuthentication;
                if (event) {
                    for (var attribute in modelAttributes) {
                        if (modelAttributes.hasOwnProperty(attribute) && event.hasOwnProperty(modelAttributes[attribute].eventName)) {
                            nameByAuthentication = !!event.isAuthenticated ? modelAttributes[attribute].eventName : modelAttributes[attribute].name;
                            // New SDEs will have the serverTimeStamp only in the root.
                            if (!event[modelAttributes[attribute].eventName].hasOwnProperty('serverTimeStamp') && event.hasOwnProperty('serverTimeStamp')) {
                                event[modelAttributes[attribute].eventName].serverTimeStamp = event.serverTimeStamp;
                            }
                            handleSingleEvent(event[modelAttributes[attribute].eventName], collection, modelAttributes[attribute].callback, nameByAuthentication);
                            break;
                        }
                    }
                }
            }
        }

        /**
         * Replaced events with the processed data from the context (if it exists)
         * @param collection - destination collection to hold the events in the sub objects according to the event's name
         * @param [context] - Optional context for SDEs
         */
        function getEventsFromContext(collection, context) {
            if (context) {
                for (var attribute in modelAttributes) {
                    if (modelAttributes.hasOwnProperty(attribute) && modelAttributes[attribute].context && context.hasOwnProperty(modelAttributes[attribute].context)) {
                        collection[modelAttributes[attribute].name] = [];
                        var eventContext = context[modelAttributes[attribute].context];
                        if (eventContext.constructor === Array) {
                            for (var contextIndex = 0; contextIndex < eventContext.length; contextIndex++ ) {
                                handleSingleEvent(eventContext[contextIndex], collection, modelAttributes[attribute].callback, modelAttributes[attribute].name);
                            }
                        } else {
                            handleSingleEvent(eventContext, collection, modelAttributes[attribute].callback, modelAttributes[attribute].name);
                        }
                    }
                }
                // Example JSON for seamless SDEs.
                // TODO: Remove from final code. Instead get the seamless object from the collection/context
                var seamless = getDemoSeamlessSDEs();
                collection.seamless = [];
                // End of JSON example
                for (var sde in seamless) {
                    if (seamless.hasOwnProperty(sde) && seamless[sde].length > 0) {
                        for(var i = 0; i < seamless[sde].length; i++) {
                            handleSingleEvent(seamless[sde][i], collection, getProcessedSeamlessEvent, 'seamless', sde, i);
                        }
                    }
                }
                // The rawSeamless is for the SDK. We need it as well as the processed data.
                collection.rawSeamless = seamless;
            }
        }

        /**
         * This method set's the events sub objects to their wanted order.
         * @param collection
         */
        function orderAndTrimEventsByType(collection) {
            if (collection) {
                for (var modelAttribute in modelAttributes) {
                    if (modelAttributes.hasOwnProperty(modelAttribute)) {
                        orderEvents(collection[modelAttribute], modelAttributes[modelAttribute].reversed);
                        trimEvents(collection[modelAttribute], modelAttributes[modelAttribute].shouldTrim);
                    }
                }
            }
        }

        /**
         * This method will process a single event and will determine to which sub object on the collection it belongs
         * @param rawEvent - raw event to process
         * @param collection - destination collection to hold the events in the sub objects according to the event's name
         * @param getProcessedEvent - callback to get the processed event
         * @param name - event name
         * @param innerName - Name of Seamless SDE for identification
         * @param index - Index of Seamsless SDE for identification
         */
        function handleSingleEvent(rawEvent, collection, getProcessedEvent, name, innerName, index) {
            var processedEvent = getProcessedEvent(rawEvent, innerName, index);
            if (collection) {
                if (!rawEvent.isAuthenticated) {
                    if (!collection.hasOwnProperty(name)) {
                        collection[name] = [];
                    }
                    collection[name].push(processedEvent);
                }
                else {
                    if (!collection.hasOwnProperty('participant')) {
                        collection.participant = {};
                        collection.participant.isAuthenticated = true;
                    }
                    if (!collection.participant.hasOwnProperty(name)) {
                        collection.participant[name] = {};
                    }
                    collection.participant[name] = processedEvent;
                }
            }
        }

        /**
         * Utility method to order the event's sub objects
         * @param collection - collection to order
         * @param reversed - if the order of events should be reversed (newest first)
         */
        function orderEvents(collection, reversed) {
            if (collection && Array.isArray(collection)) {
                collection.sort(sortingFunction);
                if (reversed) {
                    collection.reverse();
                }
            }
        }
    }

    /**
     * This is a wrapper to the process function, to allow returning of the data
     * and remove the "OUT" concept from the flow.
     * @param {*} rawEvents - array of unproceessed events from the server.
     * @param {*} context  - a context to use in the proceessing.
     */
    function getProcessedSDEsEvents(rawEvents, context){
        var retVal = {};
        handleEvents(rawEvents, retVal, context);
        return retVal;
    }

    /**
    * The following 9 functions all have the following doc:
    *
    *  Processes the shark data for the event and  returns a processed object ready to be put in the model.
    *  @param data - The raw data we receive from shark for this event.
    *  @returns Object. The processed version of the event that will be put in the model.
    **/
    //1. Personal Info
    function getProcessedPersonalInfoEvent(data) {
        var processedEvent = getCommonEventData(data);
        var dataToUse = data && data.personalInfo;
        if (dataToUse) {
            if (dataToUse.name && dataToUse.surname) {
                processedEvent.name = dataToUse.name + ' ' + dataToUse.surname;
                processedEvent.firstname = dataToUse.name;
                processedEvent.lastname = dataToUse.surname;
            } else if (dataToUse.firstname && dataToUse.lastname) {
                processedEvent.name = dataToUse.firstname + ' ' + dataToUse.lastname;
                processedEvent.firstname = dataToUse.firstname;
                processedEvent.lastname = dataToUse.lastname;
            } else {
                processedEvent.name = dataToUse.name || dataToUse.surname || dataToUse.firstname || dataToUse.lastname || undefined;
                processedEvent.firstname = dataToUse.name || dataToUse.firstname || undefined;
                processedEvent.lastname = dataToUse.surname || dataToUse.lastname || undefined;
            }

            processedEvent.gender = dataToUse.gender;
            if (dataToUse.gender && agentLEManager.hasLETranslationKey("LEWebAgent.VISIT_INFO_GENDER_" + dataToUse.gender)) {
                processedEvent.gender = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_GENDER_" + dataToUse.gender);
            }
            processedEvent.company = dataToUse.company;
            processedEvent.language = dataToUse.language;
            var age = dataToUse.customerAge || dataToUse.age;
            if (age) {
                processedEvent.age = age.customerAgeInYears || age.age;
                var year = parseInt(age.customerYearOfBirth || age.year, 10);
                var month = parseInt(age.customerMonthOfBirth || age.month, 10);
                var date = parseInt(age.customerDateOfBirth || age.day, 10);
                processedEvent.birthday = lpUtils.formatParameterDateAsString({year: year, month: month, day: date});
            }
            var contacts = dataToUse.contacts;
            if (contacts && contacts.constructor === Array) {
                processedEvent.contactInfo = [];
                for (var index = 0; index < contacts.length; index++ ) {
                    if (contacts[index]) {
                        if (contacts[index].personalContact) {
                            processedEvent.contactInfo.push({
                                email: contacts[index].personalContact.email,
                                phone: contacts[index].personalContact.phone,
                                address: contacts[index].personalContact.address,
                                preferredContactMethod: contacts[index].personalContact.preferredContactMethod
                            });
                        }
                        else {
                            processedEvent.contactInfo.push({
                                email: contacts[index].email,
                                phone: contacts[index].phone,
                                address: contacts[index].address,
                                preferredContactMethod: contacts[index].preferredContactMethod
                            });
                        }
                    }
                }
            }
        }
        return processedEvent;
    }

    //2. Customer Info
    function getProcessedCustomerInfoEvent(data) {
        var processedEvent = getCommonEventData(data);
        var dataToUse = data && data.customerInfo;
        if (dataToUse) {
            processedEvent.status = dataToUse.customerStatus || dataToUse.cstatus;
            processedEvent.type = dataToUse.customerType || dataToUse.ctype;
            processedEvent.balance = (!isNaN(dataToUse.balance) && dataToUse.balance !== null) ? getCurrencySymbolAndAmount(dataToUse.balance, dataToUse.currency) : ""; //this check is because 0, and number in str format is valid
            processedEvent.customerId = dataToUse.customerId;
            processedEvent.lastPaymentDate = lpUtils.formatParameterDateAsString(dataToUse.lastPaymentDate);
            processedEvent.registrationDate = lpUtils.formatParameterDateAsString(dataToUse.registrationDate);
            processedEvent.imei = dataToUse.imei;
            processedEvent.socialId = dataToUse.socialId;
            processedEvent.userName = dataToUse.userName;
            processedEvent.companySize = dataToUse.companySize;
            processedEvent.accountName = dataToUse.accountName;
            processedEvent.loginStatus = dataToUse.loginStatus;
            processedEvent.companyBranch = dataToUse.companyBranch;
            processedEvent.role = dataToUse.role;
            processedEvent.storeNumber = dataToUse.storeNumber;
            processedEvent.storeZipCode = dataToUse.storeZipCode;

        }
        return processedEvent;
    }

    //3. Marketing Source
    function getProcessedMarketingInfoEvent(data) {
        var processedEvent = getCommonEventData(data);
        var dataToUse = data && data.marketingCampaignInfo;
        if (dataToUse) {
            var key = 'LEFramework.marketing.originatingChannel.' + dataToUse.originatingChannel;
            if (agentLEManager.hasLETranslationKey(key)) {
                processedEvent.originatingChannel = agentLEManager.translateLE(key);
            }
            processedEvent.affiliate = dataToUse.affiliate;
            processedEvent.campaignId = dataToUse.campaignId;
        }
        return processedEvent;
    }

    //4. Visitor Error
    function getProcessedVisitorErrorEvent(data) {
        var processedEvent = getCommonEventData(data);
        var dataToUse = (data && data.visitorError) || data;
        if (dataToUse) {
            processedEvent.contextId = dataToUse.contextId;
            processedEvent.message = dataToUse.message;
            processedEvent.code = dataToUse.code;
            processedEvent.level = dataToUse.level;
            processedEvent.resolved = dataToUse.resolved;

            // remove after deprecation
            processedEvent.valueTooltip = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_visitorError");
            processedEvent.contextIdTooltip = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_contextId");
            processedEvent.messageTooltip = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_message");
            processedEvent.codeTooltip = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_code");
            processedEvent.levelTooltip = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_level");
            processedEvent.resolvedTooltip = agentLEManager.translateLE("LEWebAgent.VISIT_INFO_resolved");
        }
        return processedEvent;
    }

    //5. Lead Generation
    function getProcessedLeadEvent(data) {
        var processedEvent = getCommonEventData(data);
        var dataToUse = (data && data.lead) || data;
        if (dataToUse) {
            processedEvent.topic = dataToUse.topic;
            if (typeof dataToUse.value !== 'undefined' && dataToUse.value !== null) {
                processedEvent.value = getCurrencySymbolAndAmount(dataToUse.value, dataToUse.currency);
            }
            processedEvent.leadId = dataToUse.leadId;
        }
        return processedEvent;
    }

    //6. Service Activity
    function getProcessedServiceActivityEvent(data) {
        var processedEvent = getCommonEventData(data);
        var dataToUse = (data && data.serviceActivity) || data;
        if (dataToUse) {
            processedEvent.category = dataToUse.category;
            processedEvent.id = dataToUse.serviceId;
            var key = 'LEFramework.serviceActivity.status.' + dataToUse.status;
            if (agentLEManager.hasLETranslationKey(key)) {
                processedEvent.status = agentLEManager.translateLE(key);
            }
            processedEvent.topic = dataToUse.topic;
        }
        return processedEvent;
    }

    //7. Transactions
    function getProcessedPurchaseEvent (data) {
        var processedEvent = getProcessedCartEvent(data.cart, data.currency);
        getCommonEventData(data, processedEvent);
        if (typeof data.total !== 'undefined' && data.total !== null) {
            processedEvent.total = getCurrencySymbolAndAmount(data.total, data.currency);
        }
        processedEvent.orderId = data.orderId;
        return processedEvent;
    }

    //8. Shopping Cart Update
    function getProcessedCartEvent(data, currency) {
        var dataToUse = (data && data.cartStatus) || data;
        if (dataToUse) {
            currency = currency || dataToUse.currency;
            var processedEvent = getProcessedViewedEvent(dataToUse, currency);
            if (typeof dataToUse.total !== 'undefined' && dataToUse.total !== null) {
                processedEvent.cartTotal = getCurrencySymbolAndAmount(dataToUse.total, currency);
            }
            processedEvent.numItems = dataToUse.numItems;
            return processedEvent;
        } else {
            return {};
        }
    }

    //9. Viewed Products
    function getProcessedViewedEvent(data, currency) {
        if (data) {
            currency = currency || data.currency;
            var processedEvent = getCommonEventData(data);
            var products = data.products || data;
            if (products && products.constructor !== Array) {
                products = [products];
            }
            if (products && products.length) {
                processedEvent.products = [];
                for (var index = 0; index < products.length; index++ ) {
                    processedEvent.products.push(getProcessedProduct(products[index], currency));
                }
            }
            return processedEvent;
        } else {
            return {};
        }
    }

    //10. Searched Content
    function getProcessedSearchContentEvent(data) {

        if(!data) {
            return {};
        }

        var processedEvent = getCommonEventData(data);
        var dataToUse = (data && data.searchedInfo) || data;
        if (dataToUse && dataToUse.keywords) {
            processedEvent.keywords = dataToUse.keywords.map(function(keyword) {
                return {
                    value: keyword
                };
            });
        }
        return processedEvent;
    }

    //11. VOI
    function getProcessedVoiEvent (data) {
        var processedEvent = getCommonEventData(data);
        processedEvent.voi = data.voi;
        return processedEvent;
    }

    // function for getting demo seamless SDEs.
    // TODO: Remove when feature is finalized.
    function getDemoSeamlessSDEs() {
        return demoSeamlessSDEs;
    }
    // function for setting demo seamless SDEs.
    // TODO: Remove when feature is finalized.
    function setDemoSeamlessSDEs(data) {
        if (data && typeof data === 'object') {
            demoSeamlessSDEs = data;
        } else {
            demoSeamlessSDEs = {
                SDE1: [{
                    id: '1',
                    members: [{
                        firstName: 'John',
                        lastName: 'Doe',
                        contacts: [{
                            email: 'johnd@gmail.com',
                            phone: '555-4242'
                        }, {
                            email: 'johnd@liveperson.com',
                            phone: '740-4040'
                        }]
                    }],
                    tags: ['John', 'Doe', 'johnd']
                }],
                SDE2: [{
                    account: 'Gold',
                    id: '1234',
                    memberSince: {
                        year: 1999,
                        month: 5,
                        day: 20
                    }
                }, {
                    account: 'Silver',
                    id: '987654',
                    memberSince: {
                        year: 2016,
                        month: 7,
                        day: 15
                    }
                }],
                SDE3: [{
                    message: 'hi',
                    type: 'text',
                    sentBy: 'agent'
                }, {
                    message: 'hello',
                    type: 'text',
                    sentBy: 'visitor'
                }],
                "Financial Consumer": [{
                    creditStatus: 10, // integer
                    dataAvailability: "True", //string
                    country: "US",  //string
                    memberSince: "2001", //string
                    lastLogon: "2016-09-16T20:38:01Z", //string
                    keyIdentifier1: "582961F390F40FD25E7DFEA97", //string
                    keyIdentifier2: "256B3582961F390F40FD25E7DFEA97", //string
                    keyIdentifier3: "256B3582961F390F40FD25E7DFEA97", //string
                    securityToken: "1F390F40FD25E7DFEA97FA07E", //string
                    communicationPref: "email", //string
                    estatement: "Yes"  //string
                }],
                Account: [
                    {
                        acctHolder: "John Doe",     //string
                        number: "12345",            //string
                        status: "Active",           //string
                        type: "Personal",           //string
                        description: "Gold Card",   //string
                        tenure: "20001109",         //string OR numeric date
                        key: "D41B08595D16AA73691", //string
                        isPrimary: "yes",  //string

                        balance: {
                            paymentMessage: "Payment not required at this time",   //string
                            currentBalance: 500,  //integer
                            outstandingBalance:  350, //integer
                            recentPurchases: 150, //integer
                            minAmountDue: 25,  //integer
                            amountPastDue: 0, //integer
                            delinquentStatus: true, //string
                            payingDueDate: "2014-09-20" //string
                        },
                        rewards: {
                            rewardsActive: "yes",  //string
                            tier: "Advanced",  //string
                            rewardsAcct: "205798657",   //string
                            points: "1001", //string
                            offers: "Cash back"   //string
                        },
                        marketing:{
                            offerStart: "09/13/2016",  //string
                            offerEnd: "11/11/2016",  //string
                            offerActive: "double points",  //string
                        }
                    }
                ]
            };
        }
    }

    function getProcessedSeamlessEvent(data, name, index) {
        var processedEvent = null;
        if (data) {
            processedEvent = {
                name: name,
                id: name + '.' + index,
                flatData: []
            };
            for (var property in data) {
                if (data.hasOwnProperty(property)) {
                    getProcessedProperty(data[property], property, processedEvent);
                }
            }
        }
        return processedEvent;
    }

    function getProcessedProperty(data, name, collection) {
        if (data && name && collection) {
            if (data.year && data.month && data.day) {
                collection.flatData.push({
                    key: getTranslatedName(name, collection.name),
                    value: lpUtils.formatParameterDateAsString(data)
                });
            } else if (Array.isArray(data)) {
                if (data.length > 0) {
                    for (var i = 0; i < data.length; i++ ) {
                        getProcessedProperty(data[i], name, collection);
                    }
                }
            } else if (typeof data === 'object') {
                for (var property in data) {
                    getProcessedProperty(data[property], name + '.' + property, collection);
                }
            } else if (typeof data !== 'undefined' && data !== null) {
                collection.flatData.push({
                    key: getTranslatedName(name, collection.name),
                    value: data
                });
            }
        }
    }

    function getTranslatedName(key, sde) {
        // TODO: Need to use default English texts from the JSON schema. This was not part of the POC.
        if (lpTag.WebAgent.agentLEManager.hasLETranslationKey('LEWebAgent.seamlessSDE.' + sde + '.' + key)) {
            return lpTag.WebAgent.agentLEManager.translateLE('LEWebAgent.seamlessSDE.' + sde + '.' + key);
        }
        return key.replace(/\./g, ' ');
    }

    // ---------------HELPERS--------------
    function getProcessedProduct(rawProduct, currency) {
        var processedProduct = {};
        var dataToUse = rawProduct && rawProduct.product;
        if (dataToUse) {
            processedProduct.name = dataToUse.name;
            processedProduct.category = dataToUse.category;
            processedProduct.sku = dataToUse.sku;
            if (typeof dataToUse.price !== 'undefined' && dataToUse.price !== null) {
                processedProduct.price = getCurrencySymbolAndAmount(dataToUse.price, currency);
            }
        }
        if (rawProduct.quantity) {
            processedProduct.quantity = rawProduct.quantity;
        }
        return processedProduct;
    }

    function getCommonEventData(rawEvent, processedEvent) {
        if (!processedEvent) {
            processedEvent = {};
        }
        if (rawEvent) {
            if (rawEvent.serverTimeStamp) {
                processedEvent.serverTimeStamp = rawEvent.serverTimeStamp;
            }
            if (rawEvent.contexts) {
                if (rawEvent.contexts.engagement) {
                    processedEvent.engagementId = rawEvent.contexts.engagement.id;
                }
                if (rawEvent.contexts.page) {
                    processedEvent.pageId = rawEvent.contexts.page.id;
                }
            }
        }
        return processedEvent;
    }

    /**
     *
     * @param {Number|String} amount
     * @param {String=} code
     * @returns {string}
     */
    function getCurrencySymbolAndAmount(amount, code) {
        var separatorSpace = '';
        if (!currencySymbol) {
            var currencyObject = agentLEManager.getCurrentCurrencyObject();
            if (currencyObject && currencyObject.symbol) {
                currencySymbol = currencyObject.symbol;
            }
        }
        if(code) {
            var currencies = agentLEManager.getCurrencyList();
            var currency = currencies[code];
            if (currency && currency.symbol) {
                separatorSpace = (currency.symbol.length === 1) ? '' : ' ';
                return currency.symbol + separatorSpace + amount;
            }
            return amount + ' ' + code;
        }
        separatorSpace = (currencySymbol.length === 1) ? '' : ' ';
        return currencySymbol + separatorSpace  + amount;
    }

    return lpSdeDataHandler;

});
